export class PhotoProfileDTO {
  constructor(
    public readonly small: string,
    public readonly large: string,
    public readonly containPersonalData: boolean
  ) {}
  public static hydrate(obj: PhotoProfileDTO): PhotoProfileDTO {
    return new PhotoProfileDTO(obj.small, obj.large, obj.containPersonalData);
  }
}
